export default __webpack_public_path__ + "static/media/next.31fe8036.svg";